
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma-related types and utilities in a browser. 
 * Use it to get access to models, enums, and input types.
 * 
 * This file does not contain a `PrismaClient` class, nor several other helpers that are intended as server-side only.
 * See `client.ts` for the standard, server-side entry point.
 *
 * 🟢 You can import this file directly.
 */

import * as Prisma from './internal/prismaNamespaceBrowser.ts'
export { Prisma }
export * as $Enums from './enums.ts'
export * from './enums.ts';
/**
 * Model SuperAdmin
 * 
 */
export type SuperAdmin = Prisma.SuperAdminModel
/**
 * Model PlatoUser
 * 
 */
export type PlatoUser = Prisma.PlatoUserModel
/**
 * Model PlatoCustomer
 * 
 */
export type PlatoCustomer = Prisma.PlatoCustomerModel
/**
 * Model PlatoApiKey
 * 
 */
export type PlatoApiKey = Prisma.PlatoApiKeyModel
/**
 * Model SalesRepAssignment
 * 
 */
export type SalesRepAssignment = Prisma.SalesRepAssignmentModel
/**
 * Model UserManager
 * 
 */
export type UserManager = Prisma.UserManagerModel
/**
 * Model CrmCustomer
 * 
 */
export type CrmCustomer = Prisma.CrmCustomerModel
/**
 * Model CrmCustomerAddress
 * 
 */
export type CrmCustomerAddress = Prisma.CrmCustomerAddressModel
/**
 * Model CrmCustomerContact
 * 
 */
export type CrmCustomerContact = Prisma.CrmCustomerContactModel
/**
 * Model CrmCustomerStatusChange
 * 
 */
export type CrmCustomerStatusChange = Prisma.CrmCustomerStatusChangeModel
/**
 * Model CrmEvent
 * 
 */
export type CrmEvent = Prisma.CrmEventModel
/**
 * Model CrmEventOrder
 * 
 */
export type CrmEventOrder = Prisma.CrmEventOrderModel
/**
 * Model CrmLink
 * 
 */
export type CrmLink = Prisma.CrmLinkModel
/**
 * Model CrmInteractionLink
 * 
 */
export type CrmInteractionLink = Prisma.CrmInteractionLinkModel
/**
 * Model CrmNote
 * 
 */
export type CrmNote = Prisma.CrmNoteModel
/**
 * Model CrmTask
 * 
 */
export type CrmTask = Prisma.CrmTaskModel
/**
 * Model CrmComment
 * 
 */
export type CrmComment = Prisma.CrmCommentModel
/**
 * Model CrmAttachment
 * 
 */
export type CrmAttachment = Prisma.CrmAttachmentModel
/**
 * Model InsUsedInsight
 * 
 */
export type InsUsedInsight = Prisma.InsUsedInsightModel
/**
 * Model InsInsightOutcome
 * 
 */
export type InsInsightOutcome = Prisma.InsInsightOutcomeModel
/**
 * Model BsrBusinessRule
 * 
 */
export type BsrBusinessRule = Prisma.BsrBusinessRuleModel
/**
 * Model BsrRuleCondition
 * 
 */
export type BsrRuleCondition = Prisma.BsrRuleConditionModel
/**
 * Model BsrRuleEntityLink
 * 
 */
export type BsrRuleEntityLink = Prisma.BsrRuleEntityLinkModel
/**
 * Model BsrRuleSource
 * 
 */
export type BsrRuleSource = Prisma.BsrRuleSourceModel
/**
 * Model AiSuggestionFeedback
 * 
 */
export type AiSuggestionFeedback = Prisma.AiSuggestionFeedbackModel
/**
 * Model AiChatConversation
 * 
 */
export type AiChatConversation = Prisma.AiChatConversationModel
/**
 * Model AiChatMessage
 * 
 */
export type AiChatMessage = Prisma.AiChatMessageModel
/**
 * Model UiFilterView
 * 
 */
export type UiFilterView = Prisma.UiFilterViewModel
/**
 * Model DraftSalesOrder
 * 
 */
export type DraftSalesOrder = Prisma.DraftSalesOrderModel
/**
 * Model CrmCampaign
 * 
 */
export type CrmCampaign = Prisma.CrmCampaignModel
/**
 * Model CrmCampaignAudience
 * 
 */
export type CrmCampaignAudience = Prisma.CrmCampaignAudienceModel
/**
 * Model CrmCampaignItem
 * 
 */
export type CrmCampaignItem = Prisma.CrmCampaignItemModel
/**
 * Model CrmCampaignOutcome
 * 
 */
export type CrmCampaignOutcome = Prisma.CrmCampaignOutcomeModel
